import { useState } from "react";
import { X } from "lucide-react";
import ProgramRules from "./ProgramRules";
import ProgramPolicies from "./ProgramPolicies";
import ComplianceFindings from "./ComplianceFindings";

export default function RulesAccessModal({
  brandId, program, canManage, initialTab, onClose, onSaved, onOverride, onReinspect, inspecting,
}) {
  const [tab, setTab] = useState(initialTab || "rules");
  return (
    <div className="fixed inset-0 z-50 bg-[#1A1F2C]/70 backdrop-blur-sm flex items-start justify-center p-4 overflow-auto" onClick={onClose}>
      <div data-testid="rules-access-modal" className="bg-[#F8F5EE] rounded-xl w-full max-w-4xl my-6 shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-6 py-4 border-b border-[#1A1F2C]/10">
          <div>
            <p className="text-[10px] uppercase tracking-[0.22em] text-[#B5462F]">{program.name}</p>
            <div className="flex gap-1 mt-2">
              {[["rules", "Rules"], ["access", "Access Restrictions"]].map(([id, label]) => (
                <button
                  key={id}
                  data-testid={`rules-access-tab-${id}`}
                  onClick={() => setTab(id)}
                  className={`px-3 py-1.5 text-xs tracking-wide rounded-full ${tab === id ? "bg-[#1A1F2C] text-[#F8F5EE]" : "text-[#6B6358]"}`}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>
          <button data-testid="rules-access-close" onClick={onClose} className="p-2 text-[#6B6358] hover:text-[#1A1F2C]"><X size={20} /></button>
        </div>
        <div className="p-6">
          {tab === "rules" ? (
            <div className="space-y-5">
              {program.creative_sample?.pdf_url && (
                <div>
                  <h4 className="text-xs uppercase tracking-[0.18em] text-[#1A1F2C] font-medium mb-1">AI brand-compliance check</h4>
                  <p className="text-xs text-[#6B6358] mb-3">
                    How the creative sample measures against this brand’s active rules. Override a finding to accept it for this program.
                  </p>
                  <ComplianceFindings
                    program={program}
                    canManage={canManage}
                    onOverride={onOverride}
                    onReinspect={onReinspect}
                    inspecting={inspecting}
                  />
                </div>
              )}
              <div className="pt-2 border-t border-[#1A1F2C]/10">
                <h4 className="text-xs uppercase tracking-[0.18em] text-[#1A1F2C] font-medium mb-1">Program guidance rules</h4>
                <p className="text-xs text-[#6B6358] mb-3">These take precedence over brand rules at assembly time.</p>
                <ProgramRules brandId={brandId} program={program} canManage={canManage} onSaved={onSaved} />
              </div>
            </div>
          ) : (
            <ProgramPolicies brandId={brandId} program={program} onSaved={onSaved} />
          )}
        </div>
      </div>
    </div>
  );
}
